/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Resource/Active/Post
 * @desc Active node component for Resource
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Resource } from 'labstep-web/models/resource.model';
import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';

export const FilterPostNewIndexResourceActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const filter = new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'experiments.protocolValues.resource',
  );
  const filterActive = filter.isNodeActive(node);
  if (!filterActive) {
    return null;
  }

  const attributes = filter.getAttributeValues(node);

  return (
    <ReadOnMountHOC
      entityName={Resource.entityName}
      type="entities"
      params={{
        id: attributes.guid.value,
        get_single: 1,
      }}
      loading={false}
      children={({ entity }) => {
        if (!entity) {
          return null;
        }
        return (
          <RemoveLabel
            icon={ICONS.resource.primary}
            name={entity.name}
            onRemoveClick={onRemoveClick}
          />
        );
      }}
    />
  );
};
